import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import { Tooltip } from '@/ui';

import type { Props } from './types';

const ContactRow = ({ action, children, icon, label }: Props) => (
  <div className="flex items-start gap-3">
    <Tooltip content={label} triggerClassName="mt-1 flex">
      <FontAwesomeIcon
        aria-hidden={false}
        aria-label={label}
        className="text-uniform-gray-500"
        fixedWidth
        icon={icon}
        role="img"
      />
    </Tooltip>
    <div className="min-w-0 flex-1 text-sm text-uniform-gray-900 dark:text-uniform-gray-100">
      {children}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);

export default memo(ContactRow);
